import React, { useState } from 'react';
import API from '../utils/api';
import './AddProduct.css';

const AddProduct = () => {
  const [data, setData] = useState({
    companyName: '',
    modelNo: '',
    invoiceNo: '',
    invoiceDate: '',
    size: '',
    alertQty: '',
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    // Validation
    if (!data.invoiceDate) return alert("Please select invoice date");
    if (!data.modelNo.trim()) return alert("Model Number is required");
    if (!data.alertQty || data.alertQty <= 0) return alert("Please enter a valid alert quantity");
    
    setLoading(true);

    try {
      // Prepare payload
      const payload = {
        companyName: data.companyName,
        modelNo: data.modelNo || '',
        invoiceNo: data.invoiceNo || '',
        invoiceDate: data.invoiceDate,
        size: data.size,
        alertQty: Number(data.alertQty),
      };

      // Send to backend
      await API.post("/products", payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      alert("Product added successfully!");
      
      // Reset form
      setData({
        companyName: '',
        modelNo: '',
        invoiceNo: '',
        invoiceDate: '',
        size: '',
        alertQty: '',
      });

    } catch (error) {
      console.error("Error:", error);
      alert(`Error: ${error.response?.data?.message || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-product-container">
      <h2 className="add-product-title">Add Product</h2>
      <div className="form-grid">
        <input 
          className="form-input" 
          name="companyName" 
          placeholder="Company Name" 
          value={data.companyName} 
          onChange={handleChange} 
        />
        <input
          className="form-input"
          name="modelNo"
          placeholder="Model Number"
          value={data.modelNo}
          onChange={handleChange}
          required
        />
        <input
          className="form-input"
          name="invoiceNo"
          placeholder="Invoice Number"
          value={data.invoiceNo}
          onChange={handleChange}
        />
        <input 
          className="form-input" 
          type="date" 
          name="invoiceDate" 
          placeholder="Invoice Date" 
          value={data.invoiceDate} 
          onChange={handleChange} 
        />
        <input 
          className="form-input" 
          name="size" 
          placeholder="Size" 
          value={data.size} 
          onChange={handleChange} 
        />
        <input 
          className="form-input" 
          name="alertQty" 
          type="number" 
          placeholder="Minimum Quantity Before Alert" 
          value={data.alertQty} 
          onChange={handleChange} 
          min="1"
        />
        <button 
          className="submit-btn" 
          onClick={handleSubmit} 
          disabled={loading}
        >
          {loading ? 'Saving...' : 'Add Product'}
        </button>
      </div>
    </div>
  );
};

export default AddProduct;
